<template>
	<div class='title'>
		<change-password />
	</div>
</template>

<script>
import home from '@/assets/icons/teamwork.svg'
import { mapGetters } from 'vuex'
import ChangePassword from '@/modules/user/components/change-password'

export default {
	name: 'Home',
	components: {
		ChangePassword
	},

	computed: {
		...mapGetters({
			USER: 'user'
		})
	},
	data() {
		return {
			home,
			heightscreen: window.innerHeight - 120
		}
	}
}
</script>
